import * as React from "react";
import {
	ThemeProvider as NextThemesProvider,
	ThemeProviderProps,
} from "next-themes";
import { initializeIcons } from "@fluentui/react";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
	React.useEffect(() => {
		initializeIcons();
	}, []);
	return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
